import * as React from "react"
import {ProrataPeriod} from "./types"
import {SingleBox as Select} from "../../../lib/sbhtml/select"
import {HelpButton} from "../../../lib/help button"

export interface ProrataPeriodInputProps {
	value:ProrataPeriod|null
	onChange:(value:ProrataPeriod) => void
	name:string
}

export const ProrataPeriodInput = (props:ProrataPeriodInputProps) =>
	props.value === null ? <CantProrata /> :
		<Select
			value={props.value}
			onChange={(value: string) => props.onChange(value as ProrataPeriod)}
			name={props.name}
		>
			<option value="none">No Pro-rata</option>
			<option value="daily">Daily</option>
			<option value="weekly">Weekly</option>
			<option value="monthly">Monthly</option>
			<option value="quarterly">Quarterly</option>
			<option value="6 monthly">Six monthly</option>
			<option value="annually">Annually</option>
		</Select>

const CantProrata = () =>
	<div>
		<span>N/A</span>
		<HelpButton message="Only membership types with fixed expiry dates can specify pro-rata periods." />
	</div>



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/common/presentation.tsx